import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BackToParentFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.14 17.16H12.98C15.44 17.16 17.3 15.36 17.3 12.98C17.3 10.62 15.48 8.88 12.98 8.88H7.88L11.02 11.88L9.74 13.16L4.58 8L9.74 2.84L11.02 4.12L7.88 7.12H12.98C16.54 7.12 19.26 9.64 19.26 12.98C19.26 16.36 16.5 19 12.98 19H6.14V17.16Z" />
    </SvgIcon>
  );
});
